import { ChangeDetectionStrategy, Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { EmissionsNoticeVariant } from '@utils/emissionsNotice';

@Component({
  selector: 'cv-modal-emissions-notice',
  standalone: true,
  templateUrl: './modal-emissions-notice.component.html',
  styleUrl: './modal-emissions-notice.component.css',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalEmissionsNoticeComponent {
  benefits = [
    {
      icon: '◎',
      title: 'Pantallas más claras',
      description: 'Lo importante, a primera vista.',
    },
    {
      icon: '☰',
      title: 'Filtros a la vista',
      description: 'Encontrá el vuelo sin buscar menús.',
    },
    {
      icon: '→',
      title: 'Reservas más ágiles',
      description: 'Menos pasos para emitir.',
    },
  ];

  steps = [
    {
      day: '28',
      month: 'Oct',
      title: 'Miércoles 28/10',
      description: 'Podés elegir qué diseño usar para emitir tus tickets.',
      oldDesignAvailable: true,
    },
    {
      day: '9',
      month: 'Nov',
      title: 'Lunes 9/11',
      description: 'Cambiamos el diseño, y sólo podés acceder a la nueva versión.',
      oldDesignAvailable: false,
    },
  ];

  variant: EmissionsNoticeVariant;

  constructor(
    private dialogRef: MatDialogRef<ModalEmissionsNoticeComponent>,
    @Inject(MAT_DIALOG_DATA) data: { variant?: EmissionsNoticeVariant } | null,
  ) {
    this.variant = data?.variant ?? 'announcement';
  }

  close(): void {
    this.dialogRef.close();
  }
}
